export enum AxonViLPRCameraModel {
  AXON_FLEET_3_HUB = 'axon_fleet_3_hub',
  AXON_OUTPOST = 'axon_outpost',
  AXON_LIGHTPOST = 'axon_lightpost',
}

export enum AxonViLPRCameraModelDisplayName {
  AXON_FLEET_3_HUB = 'Fleet 3',
  AXON_OUTPOST = 'Outpost',
  AXON_LIGHTPOST = 'Lightpost',
}
